import {Button, ButtonProps, Dimmer, Input, Loader, Modal} from 'semantic-ui-react';
import React, {useState} from 'react';


interface ConfirmModalProps {
  visible?: boolean;
  loading?: boolean;
  title?: string;

  confirmButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;

  children?: React.ReactNode;

  onConfirm?: () => void;
  onCancel?: () => void;
}

export const CodeConfirmationModal = (props: ConfirmModalProps) => {
  const [requiredCode] = useState('' + Math.floor(1000 + (Math.random() * 9000)));
  const [codeInput, updateCodeInput] = useState('');

  const cancel = () => props.onCancel ? props.onCancel() : null;
  const confirm = () => props.onConfirm ? props.onConfirm() : null;

  return (<Modal open={props.visible}>
    <Dimmer active={props.loading}>
      <Loader />
    </Dimmer>
    <Modal.Header>{props.title || 'Aktion bestätigen'}</Modal.Header>
    <Modal.Content>
      {props.children}
      <p>Zur Bestätigung bitte <strong>{requiredCode}</strong> eingeben.</p>
      <Input fluid pattern="[0-9]{4}" value={codeInput} onChange={(_,data) => updateCodeInput(data.value)} />
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={() => cancel()}
              content="Abbrechen"
              disabled={props.loading}
              {...props.cancelButtonProps}
              />
      <Button onClick={() => confirm()}
              disabled={props.loading || requiredCode !== codeInput}
              content="Bestätigen"
              {...props.confirmButtonProps} />
    </Modal.Actions>
  </Modal>)
};